/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type ItemPreviews_viewer$ref: FragmentReference;
export type ItemPreviews_viewer = {|
  +isVisuallySimilarEnabled: ?boolean,
  +$refType: ItemPreviews_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "ItemPreviews_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "isVisuallySimilarEnabled",
      "name": "isEnabledByLocale",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "VISUALLY_SIMILAR",
          "type": "String!"
        }
      ],
      "storageKey": "isEnabledByLocale(featureName:\"VISUALLY_SIMILAR\")"
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '1e6484c7589bb1db209abc37afbaf16a';
module.exports = node;
